import type { View } from "@-/com.npmjs.react-native";
import { createContext, type RefObject } from "react";

export type BackdropRef = RefObject<View | null>;
type BackdropRegistry = {
  register: (target: BackdropRef, depth: number) => () => void;
  target: BackdropRef | null;
};

export const FrostedBackdropContext = createContext<BackdropRegistry | null>(null);
export const EMPTY_CAPTURED_BACKDROPS: readonly BackdropRef[] = [];
export const CapturedBackdropContext = createContext(EMPTY_CAPTURED_BACKDROPS);
export const BackdropRegistrationContext = createContext(true);
